const AnalyticsIcon = () => {
  return (
    <svg
      className="animate-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 117 111"
      fill="none"
      shapeRendering="geometricPrecision"
      style={{
        position: 'absolute',
        width: '117px',
        height: '111px',
        bottom: 0,
        right: 0,
        transition: 'opacity 0.25s ease-in-out',
      }}
    >
      <rect
        className="animate-bar-1"
        x="1"
        y="74"
        width="40"
        height="46"
        rx="3"
        fill="#fff"
        stroke="#2d426a"
        strokeWidth={2}
      />
      <rect
        className="animate-bar-2"
        x="41"
        y="1"
        width="40"
        height="119"
        rx="3"
        fill="#5bd992"
        stroke="#2d426a"
        strokeWidth={2}
      />
      <rect
        className="animate-bar-3"
        x="81"
        y="37"
        width="40"
        height="83"
        rx="3"
        fill="#fff"
        stroke="#2d426a"
        strokeWidth={2}
      />
    </svg>
  );
};

export default AnalyticsIcon;
